export const labels = {
	None: {
		label: "Label.MobileCreator.BottomMenu.Photo.Filters.None",
		default: "Original",
	},
} as const;
